import { type FC } from 'react';
import { ToolNavigationLinkActiveDot } from './ToolNavigationLinkActiveDot';
import classes from '../styles/index.module.css';
import RouteLink from '../../../components/RouteLink';

export type ToolNavigationLinkProps = {
	isActive?: boolean;
	url: string;
	title: string;
	dataTestId?: string;
	onClick: () => void;
	target?: '_blank' | '_self';
};

export const ToolNavigationLink: FC<ToolNavigationLinkProps> = ({
	isActive,
	url,
	title,
	dataTestId,
	onClick,
	target,
}) => {
	return (
		<RouteLink
			className={classes.toolNavigationLink}
			href={url}
			hasColor={false}
			onClick={onClick}
			dataTestId={dataTestId}
			useDirty
			target={target}
		>
			<span className={classes.toolNavigationLink__leftColumn}>
				{isActive && <ToolNavigationLinkActiveDot />}
			</span>
			<span className={classes.toolNavigationLink__rightColumn}>{title}</span>
		</RouteLink>
	);
};
